document.querySelectorAll('.hacklabr-slider-block').forEach((container) => {
    const params = JSON.parse(container.querySelector('script').innerHTML);
    const wrapper = container.querySelector('.swiper');
    const swiper = hl_createSwiper(wrapper, {
        ...params,
    });

    const prevBtn = container.querySelector('.swiper-button-prev');
    const nextBtn = container.querySelector('.swiper-button-next');

    if (prevBtn && !prevBtn.querySelector('.screen-reader-text')) {
        const srText = document.createElement('span');
        srText.className = 'screen-reader-text';
        srText.textContent = 'Slide anterior';
        prevBtn.insertBefore(srText, prevBtn.firstChild);
    }

    if (nextBtn && !nextBtn.querySelector('.screen-reader-text')) {
        const srText = document.createElement('span');
        srText.className = 'screen-reader-text';
        srText.textContent = 'Próximo slide';
        nextBtn.insertBefore(srText, nextBtn.firstChild);
    }

    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Carrossel de slides');

    const slides = wrapper.querySelectorAll('.swiper-slide[role="group"]');
    slides.forEach((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-label', `Slide ${index + 1} de ${slides.length}`);
    });
});
